const GUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isPowerBiReportGuid (value: string | undefined | null): boolean {
  if (value == null || typeof value !== 'string') return false;
  const t = value.trim();
  return t.length > 0 && GUID_RE.test(t);
}
